import { Component, inject, OnInit } from '@angular/core';
import { InfoService } from '../../shared/services/info.service';
import { LfwRouterService } from '../../route/lfw-router.service';
import { ProjectsService } from '../projects.service';
import { SelectionArguments } from '../../shared/models/selection-arguments';
import { SelectionType } from '../../shared/enums/selection-type';
import { ProjectListViewComponent } from '../components/project-list-view/project-list-view.component';
import { LFProject } from '@lfw/roesberg.liveforms.core';

@Component({
  selector: 'lfw-project-page',
  templateUrl: './project-page.component.html',
  styleUrl: './project-page.component.css',
  imports: [ProjectListViewComponent]
})
export class ProjectPageComponent implements OnInit {
  projects?: LFProject[] = undefined;

  private projectService = inject(ProjectsService);
  private infoService = inject(InfoService);
  private lfwRouterService = inject(LfwRouterService);

  constructor() {
    this.infoService.clearStatus();
  }

  ngOnInit(): void {
    this.projectService.allProjects$.subscribe((res) => {
      this.projects = res;
      this.infoService.setLoadedItems(this.projects.length);
    });
  }

  onProjectSelected(args: SelectionArguments) {
    if (args != undefined && args.action == SelectionType.Selected) {
      this.projectService.selectProject(args.id).subscribe((res) => {
        if (res) {
          this.lfwRouterService.navigateToOrdersRoot();
        } else {
          this.lfwRouterService.errorStop('PROJECTSELECTERROR');
        }
      });
    }
  }
}
